import { openApi } from "./request";

export const deleteFile = (id: number) => {
  openApi('delete', `/file/${id}`)
    .then((result: any) => {

    })
}